import styles from './tableHeader.module.css';

const TableHeader = ({ columns }) => {
    return (
        <thead className={styles.tableHead}>
            <tr>
                {columns.map((column, index) => {
                    return <th key={index}>{column.label}</th>;
                })}
            </tr>
        </thead>
    );
};

export default TableHeader;
